import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import packageJson from '../../../../package.json';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() location: any;
  @Output() toggledSidenav = new EventEmitter<boolean>();
  showingSidenav = true;
  userInfo;
  name;
  base;
  isLoading;
  public version: string = packageJson.version;

  constructor( public cookieService: CookieService) {}

  ngOnInit(): void {
    // on first load we create the header before the user is defined in local storage. this is just a little function to watch the local storage while the user is logging in.
    this.getInitialUserInfo();
  }

  getInitialUserInfo = () => {
    if (!this.userInfo) {
      this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
      setTimeout(() => this.getInitialUserInfo(), 1000 );
    }
  }

  toggleSidenav = () => {
    this.showingSidenav = !this.showingSidenav;
    this.toggledSidenav.emit(this.showingSidenav);
  };

  getInfo = (parameter) => {
    return this.userInfo ? this.userInfo[parameter] : '';
  }

  // although we have removed the logout button, we are still interested in getting logout working, so this wip logout function was not removed
  logout = async () => {
    
    const singleUrlSignOut = (url, popup: Window) => {
      console.log(`current logout URL: [${url}]`)
      return new Promise((resolve, reject) => {
        popup.location = url;
        /*
        Note: This is having some intermittent problems where it doesn't log out of eAuth (and possibly others?).
        Some folks on some devices experience this <5% of the time.  Others experience it about 50% of the time.
        Theory:
          - 0.5 seconds is not long enough for eAuth to always log out.
          - 2 seconds should do the trick.
        */
        setTimeout(resolve, 4000);
      });
    };

    // save id needed for FSApps NxtGen logout
    let fsAppsId = window.sessionStorage.getItem('fsAppsId');

    this.isLoading = true;
    
    let fsAppsLogoutUrl = environment.FSAPPS_NXTGEN_AUTH_URL + `/connect/logout?id_token_hint=${fsAppsId}`;
    const logoutUrls = [fsAppsLogoutUrl, 'https://idp.int.identitysandbox.gov/logout', 'https://www.cert.eauth.usda.gov/eauth/b/usda/logoff?reason=logoff',
                        'https://fsapps-stg.fs2c.usda.gov/logout'];
    
    const popup = window.open('', '_blank', 'popup,width=300;height=300');
    window.focus();
    for (const url of logoutUrls) {
      await singleUrlSignOut(url, popup);
    }

    window.sessionStorage.clear();
    window.sessionStorage.setItem('loggedIn', 'N');
    this.cookieService.deleteAll('/');
    this.cookieService.delete('NextGenState');

    setTimeout(() => {
      this.isLoading = false;
      window.close();
    }
    , 3000);
  };
}
